export default __webpack_public_path__ + "static/media/bgBlurGamePlay.4f977e46.png";